
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import i02 from "../../img/1280/16x9/wa_0001.jpg"
import i20 from "../../img/1280/16x9/wa_0002.jpg"

const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Image = makeShortcode("Image");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={i02} mdxType="Image" />
    <Image src={i20} mdxType="Image" />
    <h1>{`What's App`}</h1>
    <p>{`Bella sagt, sie nutzt ihr GLEICHES Passwort überall. Wofür will es Anni nutzen?`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;